import script from "./CategoryFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFormView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFormView.vue?vue&type=style&index=0&id=6b704326&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b704326"]])

export default __exports__